import { ReactNode } from "react";

import {
  Box,
  BoxProps,
  Container,
  ContainerProps,
  Fade,
  styled,
} from "@mui/material";

import { Head, HeadProps } from "./Head";
import { SettingsDialog } from "../SettingsDialog";

export const Body = styled(Box)(() => ({
  flexBasis: "100%",
  overflowY: "auto",
}));

const Main = styled(Container)(({ theme }) => ({
  //
  gap: theme.spacing(1),
  padding: theme.spacing(1),
  [theme.breakpoints.up("sm")]: {
    padding: theme.spacing(2),
  },
  [theme.breakpoints.up("md")]: {
    gap: theme.spacing(2),
    padding: theme.spacing(3),
  },
  [theme.breakpoints.up("lg")]: {
    padding: theme.spacing(4),
  },
  [theme.breakpoints.up("xl")]: {
    gap: theme.spacing(3),
    padding: theme.spacing(5),
  },
}));

export const Page: React.FC<{
  children: ReactNode;
  HeadProps?: HeadProps;
  BodyProps?: BoxProps;
  MainProps?: ContainerProps;
}> = ({ BodyProps, HeadProps, MainProps, children }) => {
  return (
    <>
      <Head {...HeadProps} />
      <Body {...BodyProps}>
        <Fade appear in>
          <Main {...MainProps}>{children}</Main>
        </Fade>
      </Body>
      <SettingsDialog />
    </>
  );
};
